import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';
import { updateStatus } from 'redux/actions';
import { Status } from 'apis/Status';
import './HeatmapDiagRasterErrorScreen.css';

const ERROR_MESSAGE =
  'To re-attempt the Diagnostic Raster, please select “Rerun Diagnostic Raster” below.  If the problem persists, please contact Customer Service.';

const HeatmapDiagRasterErrorScreen = (props) => {
  const [cancelRequest, setCancelRequest] = useState(true);
  const dispatch = useDispatch();
  let errorCodeMessage = `NOT COMPLETED: The error ${props.errorCode ? 'code' : 'message'} is ${
    props.errorCode ? props.errorCode : props.getProgressErrorMsg
  }.`;

  let errorMessage = ERROR_MESSAGE;

  useEffect(() => {
    if (cancelRequest) {
      setCancelRequest((prevVal) => {
        dispatch(updateStatus(props.initiateRasterStatusName, Status.NONE));
        dispatch(updateStatus(props.progressStatusName, Status.NONE));
        props.cancelRequest();
        props.cancelStatusUriRequest();
        props.clearTimeoutAndInterval();
        return false;
      });
    }
  }, []);

  return (
    <div id="HeatmapDiagRasterErrorScreen_Container" className="HeatmapDiagRasterErrorScreen_Container">
      <div id="HeatmapDiagRasterErrorScreen_TopContainer" className="HeatmapDiagRasterErrorScreen_TopContainer">
        <div id="HeatmapDiagRasterErrorScreen_HeaderText" className={'HeatmapDiagRasterErrorScreen_HeaderText'}>
          Error
        </div>
        <div
          id="HeatmapDiagRasterErrorScreen_MessageText_Container"
          className="HeatmapDiagRasterErrorScreen_MessageText_Container"
        >
          <div
            id="HeatmapDiagRasterErrorScreen_MessageText"
            className="HeatmapDiagRasterErrorScreen_MessageText"
            data-tip={errorCodeMessage}
          >
            {errorCodeMessage}
          </div>
          <div
            id="HeatmapDiagRasterErrorScreen_MessageText"
            className="HeatmapDiagRasterErrorScreen_MessageText"
            data-tip={errorMessage}
          >
            {errorMessage}
          </div>
        </div>
      </div>
      <div id="HeatmapDiagRasterErrorScreen_BottomContainer" className="HeatmapDiagRasterErrorScreen_BottomContainer">
        <button
          type="submit"
          disabled={false}
          id="HeatmapDiagRasterErrorScreen_Bottom_ActionButton"
          className={classnames({
            HeatmapDiagRasterErrorScreen_Bottom_ActionButton: true,
            HeatmapDiagRasterErrorScreen_Bottom_ActionButton_Disabled: false
          })}
          onClick={() => {
            props.setIsRetrieveBtnTriggered(true);
            props.clearTimeoutAndInterval();
            props.resetStates();
          }}
        >
          Rerun Diagnostic Raster
        </button>
      </div>
    </div>
  );
};

export default React.memo(HeatmapDiagRasterErrorScreen);
